Namespace 'Settings.Views.AccountSettings.SocialAccounts'

class Settings.Views.AccountSettings.SocialAccounts.CreateMicrosoft365AccountView extends Backbone.View
  className: 'modal hide fade in'
  template: JST['backbone/templates/account_settings/social_accounts/create_microsoft365_account']

  events:
    'click #submit': 'submit'
    'click #cancel': 'redirectToSocialAccounts'

  initialize: (account) ->
    @account = account
    @modal = buttons: [], title: I18n.t('social_accounts.microsoft365.create.title')

  render: ->
    @$el.html(@template({account: @account}))
    @$el.modal({backdrop: 'static', keyboard: false})
    @$el.modal()

  submit: (event) ->
    mode = @$el.find('#mode').find(":selected").val()
    @$el.children('.tab-content').empty().addClass('processing')
    @_createAccount(mode)

  _createAccount: (mode) ->
    @account.set('mode', mode)
    @account.save(null, {
      success: @redirectToSocialAccounts,
      error: @onError
    })

  redirectToSocialAccounts: =>
    window.location = '/keepcon/social_accounts'

  onError: =>
    swal({
      title: I18n.t('social_accounts.microsoft365.create.error_notification.title'),
      text: I18n.t('social_accounts.microsoft365.create.error_notification.text'),
      type: 'info',
      showCancelButton: false,
      confirmButtonClass: 'close',
      cancelButtonClass: 'close',
      confirmButtonText: I18n.t('social_accounts.microsoft365.create.error_notification.button_text'),
      closeOnConfirm: true
    })
    swal.close = => @redirectToSocialAccounts()

  close: ->
    @$el.children('.tab-content').empty().addClass('processing')
    @modalTab.destroy()
